import { Component, Input, OnInit } from '@angular/core';
import { eSectionType } from 'src/app/modules/route-planner/enums/route-planning/section-type.enum';
import { Section } from 'src/app/modules/route-planner/interfaces/route-planning/section.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import {
  BOARD_OFF,
  BOARD_ON_AT_STATION,
  STATION_CODE,
  WAIT_FOR_LINE,
  TO_DIRECTION,
} from 'src/app/modules/route-planner/constants/multi-language.constants';

@Component({
    selector: 'app-source-destination-route-tracking-section',
    templateUrl: './source-destination-route-tracking-section.component.html',
    styleUrl: './source-destination-route-tracking-section.component.scss',
    standalone: false
})
export class SourceDestinationRouteTrackingSectionComponent implements OnInit {
  @Input() isActive: boolean;
  @Input() section: Section;
  @Input() isUserOnBus: boolean = false; // Whether user has boarded the bus
  @Input() boardedBusSectionIndex: number | null = null; // Index of section where user boarded
  /** Global UI step index (swipes / auto-advance). */
  @Input() currentSectionIndex: number = 0;
  /**
   * Index of {@link section} in `RoutePlanning.sections`. Used so each preview card shows
   * boarding vs alight for **that** leg — not the same mode for every card when `currentSectionIndex` matches boarded.
   */
  @Input() sectionRouteIndex: number = -1;

  sectionTypes = eSectionType;
  dropOffText: string = '';
  boardOnText: string = '';
  stationCodeText: string = '';
  waitForLineText: string = '';
  toDirectionText: string = '';

  constructor(private readonly languageService: LanguageService) {}

  ngOnInit(): void {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.dropOffText = BOARD_OFF[language.language];
      this.boardOnText = BOARD_ON_AT_STATION[language.language];
      this.stationCodeText = STATION_CODE[language.language];
      this.waitForLineText = WAIT_FOR_LINE[language.language];
      this.toDirectionText = TO_DIRECTION[language.language];
    });
  }

  /** Line number / name for “wait for line …” while at boarding stop. */
  get transportLineLabel(): string {
    const t = this.section?.transport;
    if (!t) return '';
    const label = (t.shortName || t.name || t.longName || t.description || '').trim();
    return label;
  }
  
  // Determine if we should show boarding (departure) or drop-off (arrival) info
  // Show drop-off only on the **card whose section** is the one the user boarded — not using
  // global `currentSectionIndex`, which is identical for both stacked cards and mislabels transfers.
  get shouldShowDropOff(): boolean {
    if (!this.isUserOnBus || this.boardedBusSectionIndex === null) {
      return false;
    }
    if (this.sectionRouteIndex >= 0) {
      return this.sectionRouteIndex === this.boardedBusSectionIndex;
    }
    return this.currentSectionIndex === this.boardedBusSectionIndex;
  }
}
